import type { SupplierCapability, SupplierOperation } from '@tandemone/types'

import { CapabilityProfileOperations } from './profile-operations-capability'
import { LegacyProfileOperations } from './profile-operations-legacy'

/** dual-display during the capability transition: a supplier that has re-selected
 *  in the new taxonomy shows its capabilities, one that has not yet still shows
 *  its legacy operations. presence of capability rows is the discriminator. */
export function ProfileOperations({
  companyName,
  operations,
  capabilities
}: {
  companyName: string
  operations: SupplierOperation[]
  capabilities: SupplierCapability[]
}) {
  return capabilities.length > 0 ? (
    <CapabilityProfileOperations
      companyName={companyName}
      rows={capabilities}
    />
  ) : (
    <LegacyProfileOperations companyName={companyName} rows={operations} />
  )
}
